import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';
import { IResponseBadRequest } from '@interfaces/.';
import { Store } from '@ngrx/store';
import { USER_CLEAR_STATE } from '@/store/actions';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private isUnauthorizedShown = false;
  private isTimeoutShown = false;     // Estado compartido para 408
  private debounceTime = 5000;

  constructor(private router: Router, private store: Store) {}
  
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((response: HttpErrorResponse) => {

        const error = response?.error;

        const { error: errors, message } = error || {};

        const details = Array.isArray(error?.details)
          ? error.details.join(', ')
          : (typeof error?.details === 'string' ? error.details : null);

        let errorMessage: IResponseBadRequest = {
          success: false,
          statusCode: error?.statusCode,
          propagate: this.isUnauthorizedShown || this.isTimeoutShown ? true : false,
          message: 'An unexpected error occurred',
          error: error?.error ?? ''
        };

        if(!errors && !!Array.isArray(error)) return throwError(() => {
          return {
          ...errorMessage,
          message: Array.isArray(error) ? error?.join(', ') || 'An unexpected error occurred' : 'An unexpected error occurred',
        }});
        
        if (error instanceof ErrorEvent) {
          errorMessage.message = message;
          errorMessage.error = 'Client Error';
        } else {

          errorMessage.message = details || message || errors?.error || errors?.message || message?.message || error?.error || 'Request Timeout';
          errorMessage.error = errorMessage.error || 'Server Error';
          
          if (error.statusCode === 401 && !this.isUnauthorizedShown) {
            this.isUnauthorizedShown = true;
            // this.router.navigate(['/login'], { replaceUrl: true });
            this.store.dispatch(USER_CLEAR_STATE());
            setTimeout(() => this.isUnauthorizedShown = false, this.debounceTime);
          }
          
          if (error.statusCode === 408 && !this.isTimeoutShown) {
            this.isTimeoutShown = true;
            setTimeout(() => this.isTimeoutShown = false, this.debounceTime);
          }
        }

        return throwError(() => errorMessage);
      })
    );
  }
}